import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import StandardLayout from '../../../components/layout/StandardLayout';
import { getExam, updateExam } from '../../../services/examAPIService';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useAlert } from '../../../context/AlertContext';

const ExamEditForm = () => {
    const { id } = useParams();
    const [formData, setFormData] = useState({
        title: ''
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { showAlert } = useAlert();

    const loadExam = useCallback(async () => {
        try {
            const data = await getExam(id);
            setFormData({
                title: data.title
            });
            setError(null);
        } catch (err) {
            setError('Fehler beim Laden der Prüfung');
            console.error('Error loading exam:', err);
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        loadExam();
    }, [loadExam]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await updateExam(id, formData);
            showAlert('Prüfung wurde erfolgreich aktualisiert', 'success', true);
            navigate('/admin/exams');
        } catch (error) {
            console.error('Error updating exam:', error);
            setError('Fehler beim Aktualisieren der Prüfung');
        }
    };

    const handleCancel = () => {
        navigate('/admin/exams');
    };

    if (loading) {
        return (
            <StandardLayout>
                <div className="flex justify-center items-center min-h-screen">
                    <span className="loading loading-spinner loading-lg text-primary"></span>
                </div>
            </StandardLayout>
        );
    }

    return (
        <StandardLayout>
            <div className="container mx-auto px-4 py-8">
                <div className="max-w-2xl mx-auto">
                    <h1 className="text-2xl font-bold mb-6">Prüfung bearbeiten</h1>
                    
                    {error && (
                        <div className="alert alert-error mb-4">
                            <XMarkIcon className="w-6 h-6" />
                            <span>{error}</span>
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text">Titel</span>
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleInputChange}
                                className="input input-bordered w-full"
                                placeholder="Geben Sie den Titel der Prüfung ein"
                                required
                            />
                        </div>

                        <div className="flex justify-end gap-4">
                            <button
                                type="button"
                                onClick={handleCancel}
                                className="btn btn-ghost"
                            >
                                Abbrechen
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                            >
                                Speichern
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </StandardLayout>
    );
};

export default ExamEditForm; 